@layer components {
  .controls {
    background-color: var(--navy);
    position: sticky;
    /* iOS przesuwa widoczny obszar po otwarciu klawiatury – pasek trzymamy przy jego górze. */
    top: var(--viewport-top, 0px);
    z-index: 2;
    display: flex;
    justify-content: center;
    gap: var(--space-medium);
    width: 100%;
    padding: var(--space-medium);
    font-size: var(--font-size-large);
  }
}
